export const W_NS = 'http://schemas.openxmlformats.org/wordprocessingml/2006/main';
export const W14_NS = 'http://schemas.microsoft.com/office/word/2010/wordml';
export const XML_NS = 'http://www.w3.org/XML/1998/namespace';

export const XML_DECLARATION = '<?xml version="1.0" encoding="UTF-8" standalone="yes"?>\r\n';

export function kids(parent: Element, local: string, ns = W_NS): Element[] {
  return Array.from(parent.children).filter(
    (el) => el.namespaceURI === ns && el.localName === local,
  );
}

export function firstKid(parent: Element, local: string, ns = W_NS): Element | undefined {
  return kids(parent, local, ns)[0];
}

export function descendants(root: Element | Document, local: string, ns = W_NS): Element[] {
  return Array.from(root.getElementsByTagNameNS(ns, local));
}

export function attr(el: Element | undefined, local: string, ns = W_NS): string | undefined {
  return el?.getAttributeNS(ns, local) ?? undefined;
}
